module.exports = __webpack_public_path__ + "img/Handy Measurements.32f12f5.png";